import { Skeleton } from "@mui/material";

import { type GetLifeDetailResponse, type GetLifeDetailV2Response, ProductType } from "@repo/api";
import { useContractId } from "../../../context/ContractIDContext";
import { useLifeDetail } from "../../../queryHooks";
import { useFormatFufiTitle } from "../FufiPage/utils";

type ILifeTitle = {
    productName: string | undefined;
};

export const Title = ({ productName }: ILifeTitle) => {
    return productName ? productName : <Skeleton />;
};

export const FufiTitle = () => {
    const formatFufiTitle = useFormatFufiTitle();
    const { contractId, proposalNumber } = useContractId();
    const { data, isSuccess } = useLifeDetail<GetLifeDetailV2Response>({
        id: contractId,
        proposalNumber,
        contractType: ProductType.Clf,
        options: {
            enabled: Boolean(contractId),
        },
    });

    const title = (() => {
        if (!isSuccess) return;
        if (!data.productDescription) return "";
        return `${formatFufiTitle(data.productDescription, data.productName)}\u00A0\u00A0(${proposalNumber ?? ""})`;
    })();

    return <Title productName={title} />;
};

export const LifeTitle = () => {
    const { contractId } = useContractId();
    const { data } = useLifeDetail<GetLifeDetailResponse>({
        id: contractId,
        options: {
            enabled: Boolean(contractId),
        },
    });

    return <Title productName={data?.productName} />;
};
